import { PipeModel } from './pipeModel';

export class PipeInfoModel {
    public pipes: Array<PipeModel>;
    public lengthSum: number;
    public lengthSumRound: number;
    public unit: string;
}